<template>
  <div style="text-align:center;">
    <van-nav-bar title="个人中心" left-text="" />
    <div class="userinfo">
      <!-- <div class="user-img"></div> -->
      <!-- <van-image round width="4rem" height="4rem" fit="cover" :src="avatar" /> -->

      <!-- <div v-if="isLogined" class="user-name">
        {{user.Tel}}
        <div v-if="reward.length>0" style="width:30%;margin-top:1%;margin-right: 10px;margin-left:35%;">
          <img v-for="(item,idx) in reward" v-bind:key="idx" src="../assets/draw2024/5stars.png" style="width:30px;height:30px;display:inline;"/>
        </div>
      </div>
      <div class="login-class" v-else>
        <van-button round @click="ShowLogin" type="info" style="width:100px;">立即登录</van-button>
      </div> -->
      <!-- <div v-if="isLogined">
        <div v-if="reward.length>0" style="margin-left:10%;margin-top:10%;">
          <div style="width:25%;height:90px;float:left;">
            <img src="../assets/draw2024/5star_head.png" style="width:80px;height:90px;" />
          </div>
          <div style="width:65%;height:35%;float:left;text-align:left;font-size:15px;margin-top:3%;margin-left:3%;">
            {{user.Tel}}
          </div>
          <div style="width:65%;height:35%;float:left;text-align:left;font-size:14px;margin-top:3%;margin-left:3%;">
            <div><img src="../assets/draw2024/5stars.png" style="width:20px;height:20px;display:inline;"/></div>
            <div style="font-weight: bold;">{{reward.length}}枚勋章</div>
          </div>
          <div style="width:65%;height:55%;float:left;text-align:left;font-size:15px;margin-top:5%;margin-left:5%;">
            <van-tag type="primary" size="large" @click="toAuth()" v-if="isauth==0">立即实名</van-tag>
            <van-tag type="primary" size="large" v-else>已实名</van-tag>
            <van-tag type="primary" size="large" @click="toSign()" v-if="issign==0" style="margin-left:10px;">立即签约</van-tag>
            <van-tag type="primary" size="large" v-else style="margin-left:10px;">已签约</van-tag>
          </div>
        </div>
        <div v-else style="margin-left:10%;margin-top:10%;">
          <div style="width:25%;height:90px;float:left;">
            <img src="../assets/draw2024/pubilc_head.png" style="width:80px;height:80px;" />
          </div>
          <div style="width:65%;height:50%;float:left;text-align:left;font-size:15px;margin-top:5%;margin-left:3%;">
            {{user.Tel}}
          </div>
          <div style="width:65%;height:55%;float:left;text-align:left;font-size:15px;margin-top:5%;margin-left:5%;">
            <van-tag type="primary" size="large" @click="toAuth()" v-if="isauth==0">立即实名</van-tag>
            <van-tag type="primary" size="large" v-else>已实名</van-tag>
            <van-tag type="primary" size="large" @click="toSign()" v-if="issign==0" style="margin-left:10px;">立即签约</van-tag>
            <van-tag type="primary" size="large" v-else style="margin-left:10px;">已签约</van-tag>
          </div>
        </div>
      </div>
      
      <div class="login-class" v-else>
        <div style="width:100%;height:90px;float:left;margin-left:38%;">
          <img src="../assets/draw2024/pubilc_head.png" style="width:80px;height:80px;" />
        </div>
        <div style="width:100%;height:100%;float:left;">
          <van-button round @click="ShowLogin" type="info" style="width:100px;" size="small">立即登录</van-button>
        </div>
      </div>  -->

      <div v-if="isLogined">
        <div style="margin-left:10%;margin-top:10%;">
          <div style="width:25%;height:90px;float:left;">
            <img src="../assets/sdworker.png" style="width:100px;height:100px;" />
          </div>
          <div style="width:65%;height:50%;float:left;text-align:left;font-size:15px;margin-top:5%;margin-left:5%;">
            {{user.Tel}}
          </div>
          <div style="width:65%;height:55%;float:left;text-align:left;font-size:15px;margin-top:5%;margin-left:5%;">
            <van-tag type="danger" size="large" @click="toAuth()" v-if="isauth==0">立即实名</van-tag>
            <van-tag type="primary" size="large" v-else>已实名</van-tag>
            <van-tag type="danger" size="large" @click="toSign()" v-if="issign==0" style="margin-left:10px;">立即签约</van-tag>
            <van-tag type="primary" size="large" v-else style="margin-left:10px;">已签约</van-tag>
          </div>
        </div>
      </div>
      <div class="login-class" v-else>
        <div style="width:100%;height:90px;float:left;margin-left:35%;">
          <img src="../assets/sdworker.png" style="width:100px;height:100px;" />
        </div>
        <div style="width:100%;height:100%;float:left;">
          <van-button round @click="ShowLogin" type="info" style="width:100px;" size="small">立即登录</van-button>
        </div>
      </div> 

    </div>

    <!-- <div class="aui-flex aui-flex-three">
      <div class="aui-flex-box aui-flex-box-info">
        <h4>现金积分 <em>{{user.Integral}}</em>分</h4>
      </div>
      <div class="aui-flex-box">
        <h4>物资积分 <em>{{user.MaterialIntegral}}</em>分</h4>
      </div>
    </div> -->

    <div class="points-box">
      <van-grid :columnNum="2" size="16px">
        <van-grid-item icon="diamond-o">
          <div class="balance-text" slot="text">
            <div class="balance-name">误工积分</div>
            <div class="balance-value">{{user.Integral}}</div>
          </div>
        </van-grid-item>
        <!-- <van-grid-item icon="diamond-o">
          <div class="balance-text" slot="text">
            <div class="balance-name">物资积分</div>
            <div class="balance-value">{{user.MaterialIntegral}}</div>
          </div>
        </van-grid-item> -->
        <van-grid-item icon="diamond-o">
          <div class="balance-text" slot="text">
            <div class="balance-name">锁定积分</div>
            <div class="balance-value">{{user.LockIntegral}}</div>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    <!--活动入口-->
    <!-- <div style="margin: 5px 10px;">
      <img src="../assets/draw2023/enter_bg1.jpg" fit="contain" width="100%" alt="" @click="onActivity2Period2023()" />
    </div> -->

    <!-- <div class="aui-take-item">
      <div class="aui-flex" style="padding-bottom:0">
        <div class="aui-flex-box">
          <h1>我的订单</h1>
        </div>
        <div class="aui-arrow" @click="onClickItem()">
          <span>查看全部订单</span>
        </div>
      </div>
      <div class="aui-palace">
        <a href="javascript:;" class="aui-palace-grid" @click="onClickItem(0)">
          <div class="aui-palace-grid-icon">
            <img src="../assets/待确认.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>待确认</h2>
          </div>
        </a>
        <a href="javascript:;" class="aui-palace-grid" @click="onClickItem(1)">
          <div class="aui-palace-grid-icon">
            <img src="../assets/待发货.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>待发货</h2>
          </div>
        </a>
        <a href="javascript:;" class="aui-palace-grid" @click="onClickItem(2)">
          <div class="aui-palace-grid-icon">
            <img src="../assets/待收货.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>待收货</h2>
          </div>
        </a>
        <a href="javascript:;" class="aui-palace-grid" @click="onClickItem(3)">
          <div class="aui-palace-grid-icon">
            <img src="../assets/已完成.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>已完成</h2>
          </div>
        </a>
      </div>
    </div> -->

    <div class="aui-take-item">
      <div class="aui-flex">
        <div class="aui-flex-box">
          <h1>常用功能</h1>
        </div>
        <div class="aui-arrow" @click="quit()">
          <span>退出登录</span>
        </div>

      </div>
      <div class="aui-palace">
        <a href="javascript:;" class="aui-palace-grid" @click="onClickLog(user.ID)">
          <div class="aui-palace-grid-icon">
            <img src="../assets/积分记录.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>积分记录</h2>
          </div>
        </a>
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onClickStage(user.Tel)">
          <div class="aui-palace-grid-icon">
            <img src="../assets/阶段积分.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>年度积分</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onClickAddrs()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/收货地址.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>收货地址</h2>
          </div>
        </a> -->
        <a href="javascript:;" class="aui-palace-grid" @click="onClickAddrs()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/收货地址.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>收货地址</h2>
          </div>
        </a>
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onClickConver(user.ID)">
          <div class="aui-palace-grid-icon">
            <img src="../assets/积分转换.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>积分转换</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onLucklyDraw(1)">
          <div class="aui-palace-grid-icon">
            <img src="../assets/zhongjiang.png" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>抽奖活动</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onLucklyDraw2()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/抽福袋.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>抽奖活动</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onLucklyDrawRecord3()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/中奖记录.png" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>福袋记录</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onTeamIndex()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/抽福袋.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text" style="color:red;">
            <h2>成团活动</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onTeamLog()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/中奖记录.png" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>申请记录</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onTeamSearch()" v-if="IsShowTeamEnter">
          <div class="aui-palace-grid-icon">
            <img src="../assets/抽福袋.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>成团查询</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onClickProcess(user.ID)">
          <div class="aui-palace-grid-icon">
            <img src="../assets/阶段助力.png" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>助力进度</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onLucklyDrawRecord()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/中奖记录.png" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>中奖记录</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onMemberCard(user.ID)">
          <div class="aui-palace-grid-icon">
            <img src="../assets/会员.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>基金会会员</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onTeamRank(user.Tel)">
          <div class="aui-palace-grid-icon">
            <img src="../assets/龙虎榜.png" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>龙虎榜</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onConvert2()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/抽福袋.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text" style="color:red;">
            <h2>兑换活动</h2>
          </div>
        </a>  -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onActivity2023()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/抽福袋.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text" style="color:red;">
            <h2>升金大赢家①</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onActivity2Period2023()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/抽福袋.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text" style="color:red;">
            <h2>升金大赢家②</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onActivityPeriod2024()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/抽福袋.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text" style="color:red;">
            <h2>抽奖活动(上)</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onActivity2Period2024()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/抽福袋.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text" style="color:red;">
            <h2>抽奖活动(下)</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onMyRank()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/龙虎榜.png" alt="">
          </div>
          <div class="aui-palace-grid-text" style="color:red;">
            <h2>活动排名</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onMemberLevel()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/会员.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text" style="color:red;">
            <h2>会员中心</h2>
          </div>
        </a> -->

        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onMemberReward2025()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/抽福袋.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text" style="color:red;">
            <h2>会员奖励</h2>
          </div>
        </a> -->
        <a href="javascript:;" class="aui-palace-grid" @click="onSignReward2025()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/抽福袋.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text" style="color:red;">
            <h2>签约奖励</h2>
          </div>
        </a>
        <a href="javascript:;" class="aui-palace-grid" @click="onPeriodReward2025()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/抽福袋.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text" style="color:red;">
            <h2>阶段奖励</h2>
          </div>
        </a>
        <a href="javascript:;" class="aui-palace-grid" @click="onMyRank()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/龙虎榜.png" alt="">
          </div>
          <div class="aui-palace-grid-text" style="color:red;">
            <h2>活动排名</h2>
          </div>
        </a>
        <!-- <a href="javascript:;" class="aui-palace-grid" @click="onCompanySign2025()">
          <div class="aui-palace-grid-icon">
            <img src="../assets/抽福袋.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text" style="color:red;">
            <h2>家装签约</h2>
          </div>
        </a> -->
        <!-- <a href="javascript:;" class="aui-palace-grid">
          <div class="aui-palace-grid-icon">
            <img src="../assets/调查问卷.jpg" alt="">
          </div>
          <div class="aui-palace-grid-text">
            <h2>调查问卷</h2>
          </div>
        </a> -->
      </div>
    </div>

    <!-- <van-cell-group class="user-group">
      <van-cell icon="records" title="我的订单" is-link />
      <van-cell icon="points" title="积分记录" is-link />
    </van-cell-group>

    <van-divider contentPosition="left">物资积分余额</van-divider>

    <div class='integral-number'>
      <p>{{user.MaterialIntegral}}</p>
    </div>
    <p class='tips'>当前您的阶段性奖励积分:{{period_matintegral}}</p>
    <van-divider contentPosition="left">现金积分余额</van-divider>
    <div class='integral-number'>
      <p>{{user.Integral}}</p>
    </div> -->

  </div>
</template>

<script>
import { Row, Col, Icon, Cell, CellGroup, Grid, GridItem, Tabs, Tab, Tag } from "vant";
import { Button, Field } from "vant";
import { Divider } from "vant";
import { Popup } from "vant";
import { CountDown,NavBar } from "vant";
import wx from "weixin-js-sdk";
export default {
  name: "MyCenter",
  data() {
    return {
      IsShowTeamEnter:false,
      showLuckly2: false,
      user: {
        MaterialIntegral: 0,
        Integral: 0,
        LockIntegral: 0,
        Tel: "",
        ID: 0,
      },
      isauth:0,
      issign:0,
      // reward:{},
      qrank:0,
      qdiffcount:0,
      hrank:0,
      hdiffcount:0,
      period_matintegral: 0,
      avatar: this.$file.url + "Images/Mall/UserDefaultAvatar/" + "user.jpg"
    };
  },
  props: {},
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    wxconfig: function () {
      var that = this;
      var url = encodeURIComponent(location.href.split("#")[0]);
      // url=encodeURIComponent("https://sale.reaca.net")
      this.$http.get("WeChatApi/GetJSConfig?url=" + url).then((response) => {
        console.log(response);
        wx.config({
          debug: false,
          appId: response.data.Data.appId,
          timestamp: parseInt(response.data.Data.timestamp),
          nonceStr: response.data.Data.noncestr,
          signature: response.data.Data.sign,
          jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
        });

        wx.ready(function () {
          wx.updateAppMessageShareData({
            title: '天力管', // 分享标题
            desc: "天力管水电工程师活动中心", // 分享描述
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl: "https://oss.reaca.net/webPic/vr_logo.png", // require("../../assets/vr_logo.png"), // 分享图标
            success: function () {
              console.log("success");
              // 设置成功
            },
          });
          wx.updateTimelineShareData({
            title: that.customerInfo.CustAddress, // 分享标题
            link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
            imgUrl: "https://oss.reaca.net/webPic/vr_logo.png", //require("../../assets/vr_logo.png"), // 分享图标
            success: function () {
              console.log("success");              
            },
          });
        });
        // that.LoadImg(res);
      });
    },
    ShowLogin() {
      // this.$store.commit("showLogin");
      this.$router.push({
        name: "Login",
        params: {},
      });
    },
    GetData() {
      var that = this;
      if (this.isLogined) {
        this.$http.get("Order/GetMallSdWorkerInfo").then((res) => {
          if(res.data.Msg=="success"){
              // if (
              //   res.data.Data.ID == 30815 ||
              //   res.data.Data.ID == 42165 ||
              //   res.data.Data.ID == 19528 ||
              //   res.data.Data.ID == 42166 ||
              //   res.data.Data.ID == 50463 ||
              //   res.data.Data.ID == 50477 ||
              //   res.data.Data.ID == 50478 ||
              //   res.data.Data.ID == 13873
              // ) {
              //   that.IsShowTeamEnter = true;
              // }
              if (                
                res.data.Data.ID == 19528 ||
                res.data.Data.ID == 30815 ||
                res.data.Data.ID == 50693 ||
                res.data.Data.ID == 50694 ||
                res.data.Data.ID == 61121 ||
                res.data.Data.ID == 61122 ||
                res.data.Data.ID == 61123 ||
                res.data.Data.ID == 61124
              ) {
                that.IsShowTeamEnter = true;
              }
              
              that.user = res.data.Data;
          }
        });
        // this.$http.get("SDWorker/Get5Stars").then((res) => {
        //   if(res.data.Msg=="success"){
        //     that.reward = res.data.ListData;
        //   }
        // });
        // this.$http.get("SDWorker/GetPeriodMatIntegralByTel").then(res=>{
        //   that.$toast.clear();
        //   that.period_matintegral=res.data.Data.period_matintegral;
        // })
      }
    },
    onClickItem(status) {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "OrderList",
        params: { status: status },
      });
    },
    onClickLog(id) {
      this.$router.push({
        name: "IntegrallogList",
        params: { sdworkerid: id },
      });
    },
    onClickStage(tel) {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "StageIntegral",
        params: { tel: tel },
      });
    },
    // onLucklyDraw(period) {
    //   this.$router.push({
    //     name: "LuckDraw",
    //     params: { period: period },
    //   });
    // },
    // onLucklyDrawRecord() {
    //   this.$router.push({
    //     name: "LuckDrawRecord",
    //     params: {},
    //   });
    // },
    // onLucklyDrawRecord3() {
    //   this.$router.push({
    //     name: "LuckDrawRecord3",
    //     params: {},
    //   });
    // },
    onMemberCard(id) {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "MemberCard",
        params: { sdworkerid: id },
      });
    },
    // onClickAddrs() {
    //   if (!this.isLogined) {
    //     return this.$toast.fail("您还未登录");
    //   }
    //   this.$router.push({
    //     name: "ReciveAddrs",
    //     params: {},
    //   });
    // },
    onClickAddrs() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "PrizeAddrs",
        params: {},
      });
    },
    // onClickConver(id) {
    //   this.$router.push({
    //     name: "ConverIntegral",
    //     params: { sdworkerid: id },
    //   });
    // },
    // onLucklyDraw2() {
    //   if (!this.isLogined) {
    //     return this.$toast.fail("您还未登录");
    //   }
    //   this.$router.push({
    //     name: "LuckDraw2",
    //     params: {},
    //   });
    // },
    onTeamIndex() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "TeamIndex",
        params: {},
      });
    },
    onTeamLog() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "TeamLog",
        params: {},
      });
    },
    onTeamSearch() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "AllTeamSearch",
        params: {},
      });
    },
    onTeamRank() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "TeamRank",
        params: {},
      });
    },
    onConvert() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "PrizeList",
        params: {},
      });
    },
    onActivity2023() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "activity2023",
        params: {},
      });
    },
    onActivity2Period2023() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "activity2Period2023",
        params: {},
      });
    },
    onActivityPeriod2024() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "LuckDraw2024",
        params: {},
      });
    },
    // onMyRank() {
    //   if (!this.isLogined) {
    //     return this.$toast.fail("您还未登录");
    //   }
    //   this.$router.push({
    //     name: "MyRank",
    //     params: {},
    //   });
    // },
    onMemberLevel() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "MemberLevel",
        params: {},
      });
    },
    onActivity2Period2024() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "Luck2Draw2024",
        params: {},
      });
    },
    onMemberReward2025() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      if(this.isauth==0){
        return this.$toast.fail("您还未实名认证，请先认证");
      }
      this.$router.push({
        name: "MemberReward",
        params: {},
      });
    },
    onSignReward2025() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      if(this.issign==0){
        return this.$toast.fail("您还未签约，请先签约");
      }
      this.$router.push({
        name: "SignReward",
        params: {},
      });
    },
    onPeriodReward2025() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "PeriodReward",
        params: {},
      });
    },
    onCompanySign2025() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "CompanySign",
        params: {},
      });
    },
    // onClickProcess(id) {
    //   var that=this;
    //   this.$router.push({
    //     name: "Process",
    //     params: { sdworkerId: id },
    //   });
    // },
    onConvert2() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "Prize2List",
        params: {},
      });
    },
    toAuth() {
      this.$router.push({
        name: "Auth",
        params: {},
      });
    },
    toSign() {
      this.$router.push({
        name: "Sign",
        params: {},
      });
    },
    GetSDWorkerAuth() {
      var that = this;
      this.$http.get("Activity2025/GetSDWorkerAuth", {
        params: {},
      }).then((res) => {
        that.isauth = res.data.Data.isAuth;
      });
    },
    GetSDWorkerSign() {
      var that = this;
      this.$http.get("Activity2025/GetSDWorkerSign", {
        params: {},
      }).then((res) => {
        that.issign = res.data.Data.isSign;
      });
    },
    onMyRank() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$router.push({
        name: "MyRank2025",
        params: {},
      });
    },
    quit() {
      if (!this.isLogined) {
        return this.$toast.fail("您还未登录");
      }
      this.$dialog.confirm({
        title: "提示",
        message: "确定退出登录?",
        beforeClose: this.beforeClose,
      });
    },
    beforeClose(action, done) {
      var that = this;
      this.$http
        .get("SDWorker/SDWorkerLoginOut", {
          params: {},
        })
        .then((res) => {
          if (res.data == "success") {
            that.$store.commit("loginOut");
            that.$toast.success("退出成功");
            that.user = { MaterialIntegral: 0, Integral: 0, Tel: "", ID: 0 };
          } else {
            that.$toast(res.data);
          }
          done();
        });
    },
  },
  created() {
    console.log(this.user);
    this.wxconfig();
    this.GetData();
    this.GetSDWorkerAuth();
    this.GetSDWorkerSign();
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Divider.name]: Divider,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [CountDown.name]: CountDown,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-class {
  padding: 20px;
}
.userinfo {
  /* background-color: #ffffff; */
  background-color: #f6f6f6;
  width: 100%;
  position: relative;
  /* background-image: url('../assets/draw2024/user_center.png'); */
  background-repeat:no-repeat;
  overflow: hidden;
  background-size: contain;
  height: 180px;

  text-align: center;
  color: #323233;
  /* padding-top: 25px; */
}
.user-text {
  font-size: 14px;
}
.user-name {
  font-size: 20px;
  margin-top: 15px;
  padding-bottom: 20px;
}

.integral-number {
  font-size: 20px;
  background-color: white;
  line-height: 60px;
}
.grid-text {
  font-size: 12px;
  color: #646566;
  padding-top: 10px;
}
.tips {
  font-size: 12px;
  font-style: italic;
  padding: 10px 10px 0 10px;
  margin: 5px;
  color: gray;
  text-align: left;
}

/* 样式 */
html,
body {
  color: #333;
  margin: 0;
  height: 100%;
  font-family: "Myriad Set Pro", "Helvetica Neue", Helvetica, Arial, Verdana,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: normal;
}

a {
  text-decoration: none;
  color: #000;
}

a,
label,
button,
input,
select {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

img {
  width: 100%;
  height: auto;
  display: block;
  border: 0;
}

body {
  background: #efefef;
  color: #666;
}

html,
body,
div,
dl,
dt,
dd,
ol,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
button,
fieldset,
form,
input,
legend,
textarea,
th,
td {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
  color: #08acee;
}

button {
  outline: 0;
}

img {
  border: 0;
}

button,
input,
optgroup,
select,
textarea {
  margin: 0;
  font: inherit;
  color: inherit;
  outline: none;
}

li {
  list-style: none;
}

a {
  color: #666;
}

.clearfix::after {
  clear: both;
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
}

.aui-flex {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding: 15px;
  position: relative;
}

.aui-flex-box {
  -webkit-box-flex: 1;
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #333;
  text-align: left;
}

/* 必要布局样式css */
.aui-flexView {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
}

.aui-scrollView {
  width: 100%;
  height: 100%;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

.aui-palace {
  padding: 0.5rem 0;
  position: relative;
  overflow: hidden;
}

.aui-palace-grid {
  position: relative;
  float: left;
  padding: 1px;
  width: 25%;
  box-sizing: border-box;
  margin: 5px 0;
}

.aui-palace-grid-icon {
  width: 30px;
  height: 30px;
  margin: 0 auto;
}

.aui-palace-grid-icon img {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}

.aui-palace-grid-text {
  display: block;
  text-align: center;
  color: #333;
  font-size: 0.85rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-top: 0.2rem;
}

.aui-palace-grid-text h2 {
  font-size: 0.8rem;
  font-weight: normal;
}

.aui-flex-three {
  background: #fff;
  margin: 1rem;
  border-radius: 5px;
}

.aui-take-item {
  background: #fff;
  border-radius: 5px;
  margin: 1rem;
}

.aui-arrow {
  text-align: right;
  color: #394154;
  padding-right: 12px;
  position: relative;
  font-size: 0.85rem;
}

.aui-arrow span {
  color: #999;
  font-size: 0.8rem;
}

.aui-arrow:after {
  content: " ";
  display: inline-block;
  height: 6px;
  width: 6px;
  border-width: 2px 2px 0 0;
  border-color: #999999;
  border-style: solid;
  -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  position: relative;
  top: -2px;
  position: absolute;
  top: 50%;
  margin-top: -4px;
  right: 2px;
  border-radius: 1px;
}

.aui-flex-box h4 {
  text-align: center;
  font-weight: normal;
  color: #555555;
}

.aui-flex-box h4 em {
  font-style: normal;
  font-size: 0.9rem;
  font-weight: bold;
  color: #333;
}

.aui-flex-three {
  padding: 0.8rem;
}

.aui-flex-three .aui-flex-box-info:after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  border-right: 1px solid #d9d9d9;
  -webkit-transform: scaleX(0.5);
  transform: scaleX(0.5);
  -webkit-transform-origin: 100% 0;
  transform-origin: 100% 0;
  z-index: 22;
}

.aui-flex-box h1 {
  font-size: 1.17em;
  margin-block-start: 1em;
  margin-block-end: 1em;
}

.points-box {
  height: 80px;
  margin: 0 10px;
  text-align: center;
}
.van-grid {
  border-radius: 5px;
  margin-top: 5px;
  height: 80px;
  overflow: hidden;
}
.van-grid-item__content {
  padding: 4px;
}
.balance-text {
  margin-top: 0;
  font-size: 10px;
}
.balance-name {
  color: #666;
}
.balance-value {
  font-size: 12px;
  font-weight: bold;
  margin-top: 4px;
  color: #b00;
}

/* .user-poster {
    width: 100%;
    height: 220px;
    background: #099 center top no-repeat;
    background-size: cover;
    text-align: center;
    position: relative;
  }
  .user-info {
    padding-top: 4rem;
  }
  .user-avatar {
    align-items: center;
    margin-right:10px;
  }
  .user-info-text {
    text-align: left;
    color: #fff;
    font-size: 14px;
  }
  .user-nickname {
    font-size: 16px;
  } */
</style>
